module.exports = __webpack_public_path__ + "static/media/Team 2- Interchange 3A.3c957a67.png";